import { StyledContainer } from './Container.Styled'

const Container = ({ children, className }) => {
  return <StyledContainer className={className}>{children}</StyledContainer>
}

export default Container
